import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';
import { SvgService } from '../../../core/services';
import { ServiceOffering } from '../../models';

@Component({
  selector: 'mc-home-service-offering-card',
  templateUrl: './home-service-offering-card.component.html',
  styleUrls: ['./home-service-offering-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: {
    class: 'OfferingCard',
    '[id]': 'id()',
    '(click)': 'containerClick()',
  },
})
export class HomeServiceOfferingCardComponent {
  private readonly svgService = inject(SvgService);

  public readonly serviceOffering = input.required<ServiceOffering>();
  public readonly imageHref = input.required<string>();
  public readonly navClick = output<string | ServiceOffering>();

  protected readonly id = computed(() => `glp-card-${this.serviceOffering().elementId}`);

  protected readonly showMenu = signal<boolean>(false);

  protected toggleMenu(event: Event): void {
    event.stopPropagation();
    this.showMenu.update((showMenu) => !showMenu);
  }

  protected linkClick(link: string): void {
    this.navClick.emit(link);
  }

  protected containerClick(): void {
    if (!this.showMenu()) {
      this.navClick.emit(this.serviceOffering());
    }
  }

  protected getExtSvg(url: string) {
    return this.svgService.getExtSvg(url);
  }

  protected imageHrefIsSvg(): boolean {
    return this.imageHref().toLowerCase().endsWith('.svg');
  }
}
